import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AgentScheduleService {

  url = environment.url;
  constructor(public http: HttpClient) { }

  getSchedulesByUserId(userId) {
    return this.http.get(`${this.url}` + '/agentSchedule/getLastMonthSchedulesByUserId/' + userId).pipe(tap(res => console.log(res)),
      catchError(err => throwError(new Error('Issue in saving employee'))),
    );
  }


  getSchedulesWithSlotStatus(reqBody) {
    return this.http.post(`${this.url}` + '/agentSchedule/schedulesWithSlotStatus', reqBody).pipe(tap(res => console.log(res)),
      catchError(err => throwError(new Error('Issue in saving employee'))),
    );
  }

  assignReservation(reqBody) {
    return this.http.post(`${this.url}` + '/assignments/acceptFromWeb', reqBody).pipe(tap(res => console.log(res)),
      catchError(err => throwError(new Error('Issue in saving employee'))),
    );
  }

  assignGreetFromWEB(reqBody) {
    return this.http.post(`${this.url}` + '/assignments/assignGreetFromWEB', reqBody).pipe(tap(res => console.log(res)),
      catchError(err => throwError(new Error('Issue in saving employee'))),
    );
  }

}
